import FormItem from "app/components/inputs/FormItem";
import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { SelectStyles } from "app/routes/Calendar/EventForm/constants";
import Select from "react-select";
import { cls } from "app/utils";

interface IProps {
  lessonRates: any;
  lessonRate: any;
  handleLessonRateChange: (value: number) => void;
  isMobile?: boolean;
}

const SessionInputForm = ({
  lessonRates,
  lessonRate,
  handleLessonRateChange,
  isMobile = false,
}: IProps) => {
  const { t } = useTranslation();
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  const Control = (props: any) => {
    const handleOnClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.stopPropagation(); // avoid bubbling
      props.selectProps.menuIsOpen
        ? props.selectProps.setMenuIsOpen(false)
        : props.selectProps.setMenuIsOpen(true);
    };

    return (
      <div onClick={(e) => handleOnClick(e)} className={styles.dropdown_arrow}>
        <i
          className={cls("ico ico-chevron", menuIsOpen ? styles.rotate_up : "")}
        />
      </div>
    );
  };

  const handleChangeValue = (option) => {
    handleLessonRateChange(option);
    setMenuIsOpen(false);
  };

  const mobileProps = isMobile
    ? {
        components: { Control },
        menuIsOpen,
        setMenuIsOpen,
      }
    : {};

  const customSelectStyles = {
    ...SelectStyles,
    menu: (provided: any) => ({
      ...provided,
      width: "auto",
      ...(isMobile && {
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 0 20px 0 #00000020",
        border: "0.5px solid #00000012",
        right: 0,
        minWidth: "75vw",
      }),
    }),
  };

  return (
    <FormItem className={styles.input_field}>
      {!isMobile && <label>{t("Session")}</label>}
      <Select
        styles={customSelectStyles}
        options={lessonRates}
        value={lessonRates?.length > 0 ? lessonRate : null}
        onChange={handleChangeValue}
        isSearchable={false}
        getOptionLabel={(lessonRate) => lessonRate.title}
        getOptionValue={(lessonRate) => lessonRate.id}
        {...mobileProps}
        className={styles.sesseion_select_input}
      />
    </FormItem>
  );
};

export default SessionInputForm;
